import type { CargoItemStatusType } from 'api/swagger';
import {
  CARGO_STATUS_DELIVERED,
  CARGO_STATUS_LOADED,
  CARGO_STATUS_PLANNED,
  CARGO_STATUS_WAREHOUSE,
  CARGO_STATUS_WAITING,
  COMPLEX_STATUS_ALL_IN_PROGRESS,
  type TComplexStatusType,
} from 'types/cargo';
import type { IWarehouseGroup } from '../../hooks/use-warehouse-groups';

interface IFilterValue {
  type: CargoItemStatusType;
  fromWarehouseId?: number;
  toWarehouseId?: number | null;
}

export const buildComplexCargoFilters = (
  statusTypes: TComplexStatusType[] | undefined,
  warehouseGroups: IWarehouseGroup[] | undefined,
): IFilterValue[] => {
  if (!statusTypes?.length) {
    return [];
  }

  const expandedStatuses = new Set<TComplexStatusType>();
  statusTypes.forEach((statusType) => {
    if (statusType === COMPLEX_STATUS_ALL_IN_PROGRESS) {
      expandedStatuses.add(CARGO_STATUS_PLANNED);
      expandedStatuses.add(CARGO_STATUS_WAREHOUSE);
      expandedStatuses.add(CARGO_STATUS_LOADED);
    } else {
      expandedStatuses.add(statusType);
    }
  });

  const filters: IFilterValue[] = [];

  const allWarehouseIds = new Set<number>();
  let hasClientSelected = false;

  warehouseGroups?.forEach((group) => {
    if (group.type === 'client') {
      hasClientSelected = true;
    } else {
      group.warehouseIds.forEach((id) => allWarehouseIds.add(id));
    }
  });

  const warehouseIdsArray = Array.from(allWarehouseIds);

  expandedStatuses.forEach((status) => {
    if (status === CARGO_STATUS_WAITING || status === CARGO_STATUS_DELIVERED) {
      filters.push({ type: status });
      return;
    }

    if (status === CARGO_STATUS_WAREHOUSE) {
      warehouseIdsArray.forEach((id) => {
        filters.push({ type: status, fromWarehouseId: id });
      });
      return;
    }

    if (status === CARGO_STATUS_PLANNED || status === CARGO_STATUS_LOADED) {
      warehouseIdsArray.forEach((id) => {
        filters.push({ type: status, toWarehouseId: id });
      });

      if (hasClientSelected) {
        filters.push({ type: status, toWarehouseId: null });
      }
    }
  });

  return filters;
};
